var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Media from "react-media";
import useRovingIndex from "../../hooks/useRovingIndex";
import { Mobile } from "./Mobile";
import { Desktop } from "./Desktop";
export var TestimonialList = function (props) {
    var total = React.Children.count(props.children);
    var _a = useRovingIndex(total - 1, 0, false), currentIndex = _a[0], updateIndex = _a[1], incrementIndex = _a[2], decrementIndex = _a[3];
    return (React.createElement(Media, { query: "(min-width: 640px)" }, function (matches) {
        return matches ? (React.createElement(Desktop, __assign({ updateIndex: updateIndex, currentIndex: currentIndex }, props))) : (React.createElement(Mobile, __assign({ updateIndex: updateIndex, currentIndex: currentIndex, incrementIndex: incrementIndex, decrementIndex: decrementIndex }, props)));
    }));
};
//# sourceMappingURL=TestimonialList.js.map